/**
 * 固定UI文言の日本語リソース。
 *
 * この辞書は翻訳APIを通さず、言語ごとに人手で訳された文字列を返す用途で使う。
 * interpolation は i18next の `{{var}}` 記法で行う。
 *
 * 他言語の訳は {@link ./ja.ts} と同じキーで用意する。keys の追加時は
 * {@link ../keys.ts} も更新すること。
 */
export const ja = {
  'schedule.dueToday': '本日 {{time}}まで',
  'schedule.dueTomorrow': '明日 {{time}}まで',
  'schedule.durationRange':
    '{{start}} - {{end}}（{{currentDay}}日目/{{days}}日）',
  'editReport.defaultPageName': 'ページ {{n}}',
  'editReport.defaultSectionName': 'セクション',
  'editReport.defaultRepeatSectionName': '繰り返しセクション',
} as const
